export default __webpack_public_path__ + "static/media/EAST1840.34I-42671_-25508_0.c203c7db.jpg";